// extracted by mini-css-extract-plugin
export default {"button":"button_button__F3QR9","transparent":"button_transparent__i4+jJ","lightgray":"button_lightgray__3L7ov"};